import { call, put } from "redux-saga/effects";
import { API_URLS } from "../../../config";
import { CallApi } from "./api/callApi";
import { createDNotes, listedApplications, storeLogs, storeNotes, storeSingleApplication, storeStatusCount, updatedApplication } from "../../redux/slices/applicationSlice";
import { clearAllData } from "../../redux/slices/commonDropdownSlice";



export function* saveApplicationSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, API_URLS.APPLICATIONS.SAVE, data?.data, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(clearAllData())
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);

        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}

export function* createApplicationSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, API_URLS.APPLICATIONS.ROUTE, data?.data, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(clearAllData())
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);

        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}


export function* updateApplicationStatusSaga(action) {
    try {
        const data = action.payload;
        const { id, ...dt } = data?.data
        const resp = yield call(CallApi.PUT, API_URLS.APPLICATIONS.CHANGE_STATUS.replace(":id", id), dt, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(updatedApplication(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}



export function* assignNewUserSaga(action) {
    try {
        const data = action.payload;
        const { id, ...dt } = data?.data
        const resp = yield call(CallApi.PUT, API_URLS.APPLICATIONS.ASSIGN_USER.replace(":id", id), dt, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(updatedApplication(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}



export function* updateApplicationSaga(action) {
    try {
        const data = action.payload;
        //console.log(data?.data);
        const { _id: id, ...dt } = data?.data
        //console.log(dt);
        const resp = yield call(CallApi.PUT, `${API_URLS.APPLICATIONS.ROUTE}/${id}`, dt, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeSingleApplication(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}


export function* listApplicationSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.APPLICATIONS.ROUTE, data?.data, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(listedApplications(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}



export function* applicationStatusCountSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.APPLICATIONS.COUNT, null, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data) {
            yield put(storeStatusCount(resp?.data?.data));
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}




export function* fetchSingleApplicationSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, `${API_URLS.APPLICATIONS.ROUTE}/${data?.data?.id}`, null, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeSingleApplication(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}

// notes add and fetch
export function* createNotesSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, API_URLS.APPLICATIONS.NOTES, data?.data, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(createDNotes(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}


export function* fetchNotesSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.APPLICATIONS.NOTES, data?.data, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeNotes(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}








export function* fetchLogsSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.APPLICATIONS.ACTIVITY_LOGS, data?.data, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeLogs(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}